import { MathCompassIcon } from './MathCompassIcon';

/**
 * author: Gabriel
 * id 10E7FA7C-8451-44B9-979F-1916AAC7FE28
 * name math-compass
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-compass.svg
 * tags
 * - Math 
 * - Drawing / Art 
 * - Navigation 
 */
export const MathsCompassIcon = MathCompassIcon;
export default MathsCompassIcon